import ProxyBase from '../../../../../core/proxies/ProxyBase'

class ReportProxy extends ProxyBase {
  getSampleReport(params) {
    return this.get('SampleReport', params, 'download')
  }

  getReportItems(params) {
    return this.get('BusinessCreditReportItems', params)
  }
}

export default new ReportProxy('Report/')
